import { AdminListView } from '../list_view'
import { wrapView } from '../../smart_bps/lib/utils'
import { stateToProps } from '../../smart_bps/admin/base_view'

export class DepartmentTypeObjectTypeAdminListView extends AdminListView {
    renderTopPanelLeftItems() {
    /** Удаляем кнопку поиска **/
    let items = super.renderTopPanelLeftItems()
    if (!items) return null
    items.pop()
    return items
  }
}

export default wrapView(DepartmentTypeObjectTypeAdminListView, stateToProps)
